import React, { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import type { WithChildren } from '../../models/utils'
import CloseButton from './CloseButton'

type ModalProps = WithChildren<{
  isOpened: boolean
  onClose: () => void
}>

const Modal = ({ isOpened, onClose, children }: ModalProps): JSX.Element => {
  const modalRef = useRef<HTMLDialogElement>(null)
  const isWidget = useSelector((state: RootState) => state.viewReducer.isWidget)
  const currentWidth = useSelector((state: RootState) => state.viewReducer.currentWidth)
  const currentHeight = useSelector((state: RootState) => state.viewReducer.currentHeight)

  useEffect(() => {
    if (isOpened) {
      modalRef.current?.showModal()
    } else {
      modalRef.current?.close()
    }
  }, [isOpened])

  return (
    <dialog
      ref={modalRef}
      className='rf-absolute rf-m-0 rf-text-cardFrameText rf-bg-[#121212F2] rf-border rf-border-[#707070] rf-rounded-lg'
      style={{
        transform: isWidget
          ? `translate(calc(${window.innerWidth / 2}px - 50%), calc(${window.innerHeight / 2}px - 50%)`
          : `translate(calc(${currentWidth / 2}px - 50%), calc(${currentHeight / 2}px - 50%)`
      }}
      onCancel={onClose}
      onClick={onClose}
    >
      <div className='rf-relative rf-flex rf-flex-col' onClick={(event): void => event?.stopPropagation()}>
        <CloseButton onClick={onClose} />
        {children}
      </div>
    </dialog>
  )
}

export default Modal
